import { motion } from "framer-motion";
import { Store, Cat } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function UserTypeModal({ onSelect }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 flex items-center justify-center z-[100] px-4"
      style={{ backgroundColor: '#afd29b' }}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.1 }}
        className="bg-white rounded-3xl p-6 sm:p-10 max-w-lg w-full shadow-2xl text-center"
      >
        {/* Logo */}
        <img 
          src="https://customer-assets.emergentagent.com/job_mex-catnip-promo/artifacts/eeist4qj_LOGO%20FONDO%20TRANSPARENTE.png" 
          alt="GatoFeliz" 
          className="h-20 sm:h-24 mx-auto mb-6"
        />
        
        <h2 className="font-gluten text-2xl sm:text-3xl text-agave mb-2">
          ¡Bienvenido!
        </h2>
        <p className="font-nunito text-muted-foreground mb-8">
          Selecciona una opción para continuar
        </p>

        <div className="space-y-4">
          {/* Option 1: Cat Owner */}
          <button
            onClick={() => onSelect("owner")}
            className="w-full relative flex items-center justify-center px-6 py-6 rounded-2xl bg-mexican hover:bg-mexican/90 text-white transition-all"
            data-testid="user-type-owner"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-white absolute left-4">
              <path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"/>
              <path d="M8 14v.5"/>
              <path d="M16 14v.5"/>
              <path d="M11.25 16.25h1.5L12 17l-.75-.75Z"/>
            </svg>
            <p className="font-fredoka font-bold text-lg sm:text-xl leading-tight text-center">
              ¿TIENES GATO?
            </p>
          </button>

          {/* Option 2: Pet Store */}
          <button
            onClick={() => onSelect("business")}
            className="w-full relative flex items-center px-6 py-6 rounded-2xl bg-agave hover:bg-agave/90 text-white transition-all"
            data-testid="user-type-business"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-white flex-shrink-0">
              <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7"/>
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
              <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4"/>
              <path d="M2 7h20"/>
              <path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7"/>
            </svg>
            <p className="font-fredoka font-bold text-lg sm:text-xl leading-tight text-center flex-1 ml-4">
              ¿TIENES TIENDA DE MASCOTAS?
            </p>
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
